import { SET_BAR_STATE_TRUE, SET_BAR_STATE_FALSE, SET_BAR_MESSAGE } from "./SnackBarTypes";


export const openSnackBar = () =>{
    return {
        type: SET_BAR_STATE_TRUE
    }
}

export const closeSnackBar = () =>{
    return {
        type: SET_BAR_STATE_FALSE
    }
}

export const setBarMessage = (msg) =>{
    return {
        type: SET_BAR_MESSAGE,
        payload: msg
    }
}